function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", {
  id: "defs2708"
}, React.createElement("rect", {
  x: 421.21667,
  y: 126.47083,
  width: 256.11667,
  height: 78.316666,
  id: "rect2706"
}), React.createElement("rect", {
  x: 421.21667,
  y: 126.47083,
  width: 256.11667,
  height: 78.316666,
  id: "rect3312"
}));

var SvgHypatia = function SvgHypatia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    sodipodiDocname: "Logo_V2.svg",
    inkscapeVersion: "1.0 (4035a4fb49, 2020-05-01)",
    id: "svg2714",
    viewBox: "0 0 135.46666 135.46666",
    height: 512,
    width: 512,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    id: "layer1",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Layer 1"
  }, React.createElement("g", {
    transform: "matrix(0.09749674,0,0,0.09749674,-99.405803,335.91657)",
    id: "g2696"
  }, React.createElement("path", {
    style: {
      fill: "#1b89d1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 1846.6064,-2132.3335 -132.2917,76.3789 -396.875,-229.1358 v -389.2095 l 132.2914,-76.3786 v 389.209 z",
    id: "path2681"
  }), React.createElement("path", {
    id: "path2684",
    d: "m 2315.9629,-2556.0742 2e-4,152.7574 -396.8749,229.1359 -337.0653,-194.6047 -10e-5,-152.757 337.0649,194.6045 z",
    style: {
      fill: "#1b89d1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    style: {
      fill: "#146397",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 2183.6708,-3174.4194 132.2919,76.3786 v 458.2716 l -337.0652,194.6048 -132.2915,-76.3784 337.0649,-194.6045 z",
    id: "path2687"
  }), React.createElement("path", {
    id: "path2690",
    d: "m 1582.0225,-3369.0238 132.2918,-76.3789 396.8748,229.1358 10e-5,389.2095 -132.2914,76.3786 v -389.2091 z",
    style: {
      fill: "#146397",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    style: {
      fill: "#4daae8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 1112.666,-2945.2828 -2e-4,-152.7575 396.8748,-229.1357 337.0654,194.6046 10e-5,152.757 -337.065,-194.6045 z",
    id: "path2692"
  }), React.createElement("path", {
    id: "path2694",
    d: "m 1244.9583,-2326.938 -132.292,-76.3786 10e-5,-458.2715 337.0652,-194.6049 132.2915,76.3784 -337.065,194.6046 z",
    style: {
      fill: "#4daae8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHypatia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hypatia.33be776f.svg";
export { ForwardRef as ReactComponent };